(() => {
  if (window.BlsBannerWithTextSliderInitialized) return;
  window.BlsBannerWithTextSliderInitialized = true;

  const isDesignMode = !!(window.Shopify && window.Shopify.designMode);
  const wrapperSelector = "[data-bwt-slider-wrapper]";
  const slideSelector = "section[data-bwt-slider-group]";

  const escapeSelector = (value) => {
    if (window.CSS && typeof window.CSS.escape === "function") {
      return window.CSS.escape(value);
    }
    return value.replace(/"/g, '\\"');
  };

  const setupAutoplay = (wrapper, swiperEl) => {
    const button = wrapper.querySelector('[data-bwt-slider-pause]');
    const swiper = swiperEl.swiper;
    if (!button || !swiper?.autoplay || button.dataset.initialized) return;
    button.dataset.initialized = 'true';
    swiper.params.autoplay.disableOnInteraction = false;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let userPaused = false;
    let hovered = false;
    const sync = () => {
      const swiper = swiperEl.swiper;
      if (!swiper?.autoplay) return;
      swiper.params.autoplay.disableOnInteraction = false;
      const paused = userPaused || reducedMotion.matches;
      if (reducedMotion.matches) wrapper.querySelectorAll('.fall-rhythm__video').forEach(video => video.pause());
      button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
      button.setAttribute('aria-pressed', String(paused));
      if (paused || hovered || wrapper.contains(document.activeElement)) swiper.autoplay.stop();
      else swiper.autoplay.start();
    };
    button.addEventListener('click', () => { userPaused = !userPaused; sync(); });
    wrapper.addEventListener('mouseenter', () => { hovered = true; sync(); });
    wrapper.addEventListener('mouseleave', () => { hovered = false; sync(); });
    wrapper.addEventListener('focusin', sync);
    wrapper.addEventListener('focusout', () => setTimeout(sync, 0));
    wrapper.addEventListener('click', event => {
      const videoButton = event.target.closest('.fall-rhythm__pause');
      if (!videoButton?.closest('.swiper-slide-duplicate')) return;
      const video = videoButton.closest('.fall-rhythm').querySelector('video');
      if (video.paused) video.play().catch(() => {});
      else video.pause();
      videoButton.textContent = video.paused ? videoButton.dataset.playLabel : videoButton.dataset.pauseLabel;
      videoButton.setAttribute('aria-label', videoButton.textContent);
    });
    reducedMotion.addEventListener('change', sync);
    window.addEventListener('load', sync, { once: true });
    sync();
  };

  const initGroup = (wrapper) => {
    if (isDesignMode || document.readyState === "loading") return;
    const group = wrapper.getAttribute("data-bwt-slider-group");
    if (!group) return;

    const swiperEl = wrapper.querySelector(".bls__swiper");
    const swiperWrapper = swiperEl?.querySelector(".swiper-wrapper");
    if (!swiperEl || !swiperWrapper) return;
    if (wrapper.querySelector('[data-bwt-slider-pause]') && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      swiperEl.dataset.autoplay = 'false';
    }

    const groupSelector = `[data-bwt-slider-group=\"${escapeSelector(group)}\"]`;
    const slides = Array.from(document.querySelectorAll(`${slideSelector}${groupSelector}`)).filter((sectionEl) => {
      return sectionEl !== wrapper;
    });

    slides.forEach((sectionEl) => {
      const slideHost = sectionEl.closest(".shopify-section") || sectionEl;
      slideHost.classList.add("swiper-slide", "bwt-slider-slide");
      if (slideHost.closest(".swiper-wrapper") !== swiperWrapper) {
        swiperWrapper.appendChild(slideHost);
      }
      sectionEl.classList.add("bwt-slider-ready");
    });

    if (swiperEl.classList.contains("swiper-initialized") && swiperEl.swiper) {
      swiperEl.swiper.update();
      setupAutoplay(wrapper, swiperEl);
      window.requestAnimationFrame(() => {
        window.initBackgroundVideoToggles?.(swiperEl);
      });
      return;
    }

    if (window.BlsSettingsSwiper && typeof window.BlsSettingsSwiper.BlsCarousel === "function") {
      window.BlsSettingsSwiper.BlsCarousel(swiperEl);
      setupAutoplay(wrapper, swiperEl);
      window.requestAnimationFrame(() => {
        window.initBackgroundVideoToggles?.(swiperEl);
      });
    }
  };

  const init = () => {
    document.querySelectorAll(wrapperSelector).forEach(initGroup);
  };

  if (document.readyState === "loading") {
    let scheduled = false;
    const scheduleInit = () => {
      if (scheduled) return;
      scheduled = true;
      queueMicrotask(() => {
        scheduled = false;
        init();
      });
    };
    const earlySlideObserver = new MutationObserver(scheduleInit);
    earlySlideObserver.observe(document.body, { childList: true, subtree: true });
    document.addEventListener("DOMContentLoaded", () => {
      earlySlideObserver.disconnect();
      init();
    });
    scheduleInit();
  } else {
    init();
  }

  window.addEventListener("load", init, { once: true });
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:reorder", init);
  document.addEventListener("shopify:section:unload", init);
})();
